/**
 * Генерирует username для регистрации без поля в форме (3–30 символов, [a-zA-Z0-9_]).
 */
export const buildRegistrationUsernameFromEmail = (email: string): string => {
  const localPart: string =
    email
      .trim()
      .split('@')[0]
      ?.replace(/[^a-zA-Z0-9_]/g, '') ?? '';
  if (localPart.length >= 3) {
    return localPart.slice(0, 30);
  }
  const fromEmail: string = `u${email.replace(/[^a-zA-Z0-9]/g, '')}`;
  if (fromEmail.length >= 3) {
    return fromEmail.slice(0, 30);
  }
  return `user_${Date.now().toString(36)}`.slice(0, 30);
};

export const buildRegistrationUsernameFromPhone = (phone: string): string => {
  const digits: string = phone.replace(/\D/g, '');
  const candidate: string = `u${digits}`;
  if (candidate.length >= 3) {
    return candidate.slice(0, 30);
  }
  return `user_${digits}${Date.now().toString(36)}`.slice(0, 30);
};
